import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from 'components/Button';

const Banner = styled('div')`
  background-color: ${({ theme }) => theme.palette.primary.lighter};
  color: ${({ theme }) => theme.palette.primary.main};
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &.bottom {
    position: absolute;
    bottom: 0;
  }
  .banner-label {
    font-weight: 600;
    margin-right: 16px;
  }
`;

const StickyBannerPreview = ({ banner, color }) => {
  const [t] = useTranslation('groups');
  const { position, desc, buttonText, enabled } = banner;

  return (
    <Box className="widget-preview">
      {enabled && (
        <Banner className={position} color={color}>
          <Box className="banner-label">
            {desc ||
              t(
                'cc-form-sticky-default-desc',
                "Preregister your kids and we'll make sure our stuff is ready.",
              )}
          </Box>
          <Box className="banner-button">
            <Button size="small" variant="contained">
              {buttonText}
            </Button>
          </Box>
        </Banner>
      )}
    </Box>
  );
};

export default StickyBannerPreview;
